/**
 * Where a closed account lands. The session ended with the request that closed it, so this sits
 * with the pages for people who are not signed in.
 */

import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AuthCard } from "@/features/auth/AuthLayout";

export function AccountClosedPage() {
  const { t } = useTranslation();
  return (
    <AuthCard title={t("close.closed.title")} description={t("close.closed.body")}>
      <Link to="/auth/sign-up" className="text-brand-700 text-sm font-medium underline">
        {t("close.closed.again")}
      </Link>
    </AuthCard>
  );
}
